module.exports = __webpack_public_path__ + "img/kasundi.99d9d3d4.jpg";